
import './App.css';
import 'antd-button-color/dist/css/style.css';
import 'regenerator-runtime';
import React from 'react';
import { Amplify, Auth  } from 'aws-amplify';
import { Card, Flex } from 'antd';
import Button from "antd-button-color";



Amplify.configure({
  Auth: {

    // REQUIRED - Amazon Cognito Region
    region: process.env.REACT_APP_AWS_REGION,

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_USERPOOL_ID,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.REACT_APP_USERPOOL_WEB_CLIENT_ID,

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: false,

    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    authenticationFlowType: 'USER_PASSWORD_AUTH',

    // OPTIONAL - Hosted UI configuration
    oauth: {
      domain: `${process.env.REACT_APP_COGNITO_DOMAIN}`,
      scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: process.env.REACT_APP_AUTH_REDIRECT_URL,
      redirectSignOut: process.env.REACT_APP_AUTH_REDIRECT_LOGOUT_URL,
      responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
    }
  }
});


function App({ instance }) {

  return (

    <div className="App">

      <Flex className='Main' justify='center' align='center'>
        <Card className='Login'
          bordered={false}
          style={{ width: 400 }}
        >
          <img alt="interlogica" src="https://www.interlogica.it/wp-content/uploads/2021/10/logo_interlogica_1.svg" />
          Metahuman Authentication
          <br></br>
          <br></br>
          <Button type="success" onClick={() => Auth.federatedSignIn()} >Login</Button>
        </Card>
      </Flex>

    </div>

  );
}

export default App;
